module.exports = __webpack_public_path__ + "static/media/onedash-logo.79500055.svg";